import { sizeFor } from "../../data/imageSize";

const imageAlt = {
  "/family.webp": "Family lying in the grass",
  "/baby.webp": "Adult hands holding a baby's feet",
  "/otherFamily.webp": "Parents and child lying together",
  "/umbrella.webp": "Colorful umbrellas overhead",
  "/piggyBank.webp": "Hand placing a coin in a piggy bank",
  "/flowers.webp": "White orchids, candles, and stacked stones",
  "/employers.webp": "Coworkers meeting around a table",
  "/meeting.webp": "Team seated around a conference table",
  "/working.webp": "Coworkers reviewing plans at a table",
  "/office.webp": "Empty conference room with a long table",
  "/laptop.webp": "Hands typing on a laptop",
  "/hands.webp": "Hands stacked together",
  "/medicarePlans1.webp": "Older couple holding yellow flowers",
  "/medicarePlans2.webp": "Grandparents holding two babies",
  "/medicarePlans3.webp": "Older couple looking at a tablet",
};

export const ImageRow = ({
  header,
  images,
  imageHeight = "30vh",
  gap = "2rem",
  description,
  fontSize = "1.5rem",
  fontFamily = '"Playfair Display", Georgia, serif',
}) => {
  return (
    <>
      <div className="animate-fade-in" style={{ padding: "20px" }}>
        <h1
          style={{
            fontSize: "3rem",
            fontWeight: "normal",
            fontFamily: '"Playfair Display", Georgia, serif',
            paddingLeft: "20px",
            textAlign: "center",
            letterSpacing: "2px",
          }}
        >
          {header}
        </h1>
        <hr className="section-divider" />
      </div>
      <div
        className="animate-fade-up"
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: gap,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {images.map((src, index) => (
          <img
            key={index}
            src={src}
            alt={imageAlt[src] || header}
            {...sizeFor(src)}
            style={{
              maxHeight: imageHeight,
              width: "auto",
              height: "auto",
              objectFit: "cover",
              borderRadius: "4px",
            }}
          />
        ))}
      </div>
      <div className="page-copy">
        <p
          style={{
            fontSize: fontSize,
            fontWeight: "normal",
            fontFamily: fontFamily,
            textAlign: "center",
            justifyContent: "center", // Center the text
            letterSpacing: "1.5px", // Adds some spacing between letters for aesthetics
            alignItems: "center",
          }}
        >
          {description}
        </p>
      </div>
    </>
  );
};

export default ImageRow;
